import { IRegistration } from '../../store/registrations/interfaces'
type GenderCheckResult = {
  message?: string
  ok: boolean
}

export const checkProperGender = (
  gender: string,
  registrations: IRegistration[]
): GenderCheckResult => {
  if (!['m', 'w', 'd'].some(option => gender === option)) {
    return {
      ok: false,
      message: 'Bitte wählen Sie eine der gegebenen Optionen aus.',
    }
  }
  for (const reg of registrations) {
    //TODO: Should this not ignore family-registration?
    if (!reg.event.allowed_genders.includes(gender)) {
      return {
        ok: false,
        message: `Das ausgewählte Geschlecht ist inkompatibel mit den Voraussetzungen der Veranstaltung ${reg.event.name}!`,
      }
    }
  }
  return {
    ok: true,
  }
}
